/**
 * Part Change API — bulk PO line qty proposals from Stock Planning surfaces.
 *
 * Two endpoints:
 *   - getOpenPOLines  → populates the Propose Change modal
 *   - bulkProposeQty  → submits the bulk proposal (delegates per-line to the
 *                       existing PO line propose-quantity-change workflow)
 */
import api, { type AxiosResponse } from './client';
import type {
  OpenPOLinesResponse,
  BulkProposeRequest,
  BulkProposeResponse,
  PartChangeHistoryResponse,
} from './types/part_change';

export const partChangeAPI = {
  /** List open PO lines for a (part, supplier, customer) tuple. */
  getOpenPOLines: (params: {
    part_number: string;
    customer_id: number;
  }): Promise<AxiosResponse<OpenPOLinesResponse>> =>
    api.get('/call-off/stock-planning-proposals/open-po-lines/', { params }),

  /** Submit qty proposals against multiple open PO lines for one part. */
  bulkProposeQty: (
    data: BulkProposeRequest,
  ): Promise<AxiosResponse<BulkProposeResponse>> =>
    api.post('/call-off/stock-planning-proposals/bulk-propose-qty/', data),

  /** Supplier's part-level change history with per-line outcomes. */
  getChangeHistory: (params: {
    part_number: string;
    customer_id: number;
    limit?: number;
  }): Promise<AxiosResponse<PartChangeHistoryResponse>> =>
    api.get('/call-off/stock-planning-proposals/change-history/', { params }),
};
